import { useEffect } from 'react';
import useDataProvider, { useQuery } from '@concepta/react-data-provider';
import { GlobalStateContainer } from 'app/hooks/useGlobalState';
import { ResortInterface } from 'ks-common';
import { toast } from 'react-toastify';
import { normalizeInput } from 'utils/validators/addressMatcher';

interface UseGetAllResortsProps {
  forceRefetch?: boolean;
}

const useGetAllResorts = ({
  forceRefetch = false,
}: UseGetAllResortsProps = {}) => {
  const { globalState, updateGlobalState } =
    GlobalStateContainer.useContainer();

  const { get } = useDataProvider();

  const getResortRequest = () => {
    return get({
      uri: '/resort',
    });
  };

  const {
    data: _data,
    execute,
    isPending,
    error,
  } = useQuery(getResortRequest, false, {
    onError: error => {
      // Todo: Fix error response in rockets
      const errorRes = error as unknown as {
        response: { data: { message: string } };
      };

      toast.error(errorRes?.response?.data?.message || error?.message);
    },
  });

  const data: ResortInterface[] = globalState?.resortsList?.length
    ? globalState?.resortsList
    : _data;

  useEffect(() => {
    if (_data?.length) {
      const normalizedAddresses = _data.map((resort: ResortInterface) => ({
        street: normalizeInput(resort.Street || ''),
        city: normalizeInput(resort.City || ''),
        zip: normalizeInput(resort.ZIP || ''),
      }));
      updateGlobalState({
        resortsList: _data,
        normalizedResortAddresses: normalizedAddresses,
      });
    }
  }, [_data, updateGlobalState]);

  useEffect(() => {
    if (!globalState?.resortsList || forceRefetch) {
      execute();
    }
  }, [forceRefetch]);

  return { data, isPending, error };
};

export default useGetAllResorts;
